window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

import scroll from './modules/scroll';
import collapsible from './modules/collapsable';
import form from './modules/form';
import menu from './modules/menu';

// --------------------------  LightBox
import baguetteBox from 'baguettebox.js';
baguetteBox.run('.page-gallery');

// --------------------------  Lazy Images
import LazyLoad from "vanilla-lazyload";
new LazyLoad();

// --------------------------  MENU
menu.mainMenu();

// --------------------------  SLIDER
import { tns } from "tiny-slider/src/tiny-slider"

if (document.querySelector('.front-slider__list')) {
    const slider = tns({
        container: '.front-slider__list',
        controlsContainer: '.front-slider__controls',
        mode: 'carousel',
        mouseDrag: true,
        lazyload: true,
        lazyloadSelector: '.tns-lazy',
        controlsText: [],
        nav: true,
        navPosition: 'bottom',
        autoplayButtonOutput: false,
        //autoHeight: true,
        slideBy: 'page',
        autoplay: true
    });

    // Lazy loading SRCSETS (for SLIDER)
    const slideEvent = function (info, eventName) {

        let curItem = info.slideItems[info.index];
        let imgSources = curItem.getElementsByTagName('source');

        Array.from(imgSources).forEach(function(element) {
            let src = element.dataset.srcset
            if (src && src.length > 0) {
                element.setAttribute('srcset', src)
                element.removeAttribute('data-srcset')
            }
        })
    }

    // -------------------------- Bind function to event
    slider.events.on('transitionStart', slideEvent);
}

if (document.querySelector('.gallery-list')) {
    const privateSlider = tns({
        container: '.gallery-list',
        items: 4,
        gutter: 20,
        autoplay: false,
        loop: true,
        rewind: true,
        mode: 'carousel',
        mouseDrag: true,
        controlsText: [],
        controls: false,
        nav: true,
        navPosition: 'bottom',
        autoplayButtonOutput: false,
        autoHeight: true,
        slideBy: 'page',
        //autoWidth: true,
        fixedWidth: false,
        responsive: {
            "200": {
                fixedWidth: 300,
            },
            "500": {
                fixedWidth: 400,
                gutter: 20,
            },
            "1300": {
                fixedWidth: false,
                gutter: 20,
            }
        }
    });

    document.querySelector('.gallery-list').classList.remove('hidden')
}



// --------------------------  PHONE MASK
import IMask from 'imask'
const elPhoneField = document.getElementById('phone');
if (elPhoneField) {
    const phoneMask = IMask(
        document.getElementById('phone'), {
            mask: '+{7} (000) 000-00-00'
        })
}

scroll.scroll();

collapsible.collapsible();

form.form();
